import { AuthConfig } from 'angular-oauth2-oidc';
import { Client } from './../../shared/constants/constant';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: environment.authEndPoint,

  loginUrl: environment.authEndPoint + '/connect/authorize',

  logoutUrl: environment.authEndPoint + '/connect/endsession',

  // URL of the SPA to redirect the user to after login
  redirectUri: environment.redirectUri,

  // URL of the SPA to redirect the user after silent refresh
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',

  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: Client.ClientId,

  // set the scope for the permissions the client should request
  scope: Client.ClientScopes,

  oidc: true,
  /**
   * Defines whether https is required.
   * The default value is remoteOnly which only allows
   * http for localhost, while every other domains need
   * to be used with https.
   */
  requireHttps: !!environment.AuthRequireHttps,

  /**
   * If true, the lib will try to check whether the user
   * is still logged in on a regular basis as described
   * in http://openid.net/specs/openid-connect-session-1_0.html#ChangeNotification
   */
  sessionChecksEnabled: !!environment.AuthSessionChecksEnabled,
};
